import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticFilePipe } from './pipes/static-file.pipe';
import { FileExtensionPipe } from './pipes/file-type.pipe';
import { StaticERPLFilePipe } from './pipes/static-erpl-file.pipe';

@NgModule({
  declarations: [StaticFilePipe, FileExtensionPipe, StaticERPLFilePipe],
  imports: [CommonModule],
  exports: [StaticFilePipe, FileExtensionPipe, StaticERPLFilePipe]
})
export class StaticFileModule {}
